(function () {
  "use strict";

  class ConvxThreeSixty extends HTMLElement {
    constructor() {
      super();
      this.spinner = null;
      this.images = [];
      this.slider = null;
      this.currentIndex = 0;
      this.isDragging = false;
      this.startX = 0;
      this.totalImages = 0;
    }
  
    connectedCallback() {
      this.spinner = this.querySelector('.spinner-container');
      this.images = this.spinner.querySelectorAll('img');
      this.slider = this.querySelector('.slider');
      this.totalImages = this.images.length;
  
      this.bindEvents();
      this.updateSliderBackground();
    }
  
    bindEvents() {
      this.spinner.addEventListener('mousedown', (e) => this.startDrag(e));
      this.spinner.addEventListener('mouseup', () => this.endDrag());
      this.spinner.addEventListener('mouseleave', () => this.endDrag());
      this.spinner.addEventListener('mousemove', (e) => this.drag(e));
  
      this.spinner.addEventListener('touchstart', (e) => this.startDrag(e.touches[0]));
      this.spinner.addEventListener('touchend', () => this.endDrag());
      this.spinner.addEventListener('touchmove', (e) => this.drag(e.touches[0]));
  
      this.slider.addEventListener('input', (e) => {
        this.currentIndex = parseInt(e.target.value);
        this.showImage(this.currentIndex);
        this.updateSliderBackground(); 
      });
    }
  
    startDrag(e) {
      this.isDragging = true;
      this.startX = e.clientX;
    }
  
    endDrag() {
      this.isDragging = false;
    }
  
    drag(e) {
      if (!this.isDragging) return;
  
      const currentX = e.clientX;
      const diff = currentX - this.startX;
  
      const sensitivity = 5; // lower = faster spin
      if (Math.abs(diff) >= sensitivity) {
        if (diff > 0) {
          this.currentIndex = (this.currentIndex + 1) % this.totalImages;
        } else {
          this.currentIndex = (this.currentIndex - 1 + this.totalImages) % this.totalImages;
        }
        this.showImage(this.currentIndex);
        this.startX = currentX;
        this.updateSliderBackground();
      }
    }
  
    showImage(index) {
      this.images.forEach(img => img.classList.remove('active'));
      this.images[index].classList.add('active');
      this.slider.value = index;
    }
  
    updateSliderBackground() {
      const value = this.slider.value;
      const min = this.slider.min;
      const max = this.slider.max;
    
      // Calculate the percentage based on the slider value
      const percentage = (value - min) / (max - min);
    
      // Define the colors
      const colorStart = 'rgb(238, 27, 36)';
      const colorEnd = 'rgb(245, 246, 248)';
    
      let gradient;
    
      if (value == min) {
        // When the value is 0
        gradient = `-webkit-gradient(linear, 0% 0%, 100% 0%, from(${colorStart}), from(${colorEnd}))`;
      } else if (value == max) {
        // When the value is the maximum
        gradient = `-webkit-gradient(linear, 0% 0%, 100% 0%, to(${colorStart}), to(${colorEnd}))`;
      } else {
        // When the value is halfway or in between
        gradient = `-webkit-gradient(linear, 0% 0%, 100% 0%, color-stop(${percentage}, ${colorStart}), color-stop(${percentage}, ${colorEnd}))`;
      }
    
      // Update the background gradient of the slider
      this.slider.style.backgroundImage = gradient;
    }
    
  }
  

  class ConvxProductCard extends HTMLElement {
    connectedCallback() {
      this.setupSwatches();
    }
  
    setupSwatches() {
      const swatches = this.querySelectorAll('.convx__three-sixty-swatch');
      const label = this.querySelector('.convx__three-sixty-selected-swatch');
      const viewers = this.querySelectorAll('.convx__three-sixty-container [data-variant-id]');
      const addToCartButton = this.querySelector('.add-to-cart-button.convx__shop-now-button');
      const shopNowButton = this.querySelector('.convx__shop-now-button.convx__more-innfo-btn');
      const productCardLink = this.querySelector('.product-card-link');
      const atcFormId = this.querySelector('form[action="/cart/add"] input[name="id"]');
      const stockWrapper = this.querySelector('.stock-indicator-wrapper');
  
      if (!swatches.length ) return;
  
      swatches.forEach((swatch) => {
        swatch.addEventListener('click', function () {
          // 1. Update swatch UI
          swatches.forEach(s => s.classList.remove('active'));
          this.classList.add('active');
   
          const img = this.querySelector('img');
          const altText = img?.alt || '';
          if (label) label.textContent = altText;
  
          const targetVariantId = this.getAttribute('data-variant-id');
          const targetVariantTitle = this.getAttribute('data-variant-title'); 
          const targetVariantUrl = this.getAttribute('data-variant-url'); 
          const targetVariantStock = parseInt(this.getAttribute('data-variant-stock'), 10);
          const stockHandle = this.getAttribute('data-stock-handle');
          const stockLabel = this.getAttribute('data-stock-label');
  
          // 2. Update the selected swatch label with the variant title
          if (label) {
            label.textContent = targetVariantTitle; 
          }
  
          // 3. Update the href for .convx__shop-now-button and .product-card-link based on data-variant-url
          if (shopNowButton && targetVariantUrl) {
            shopNowButton.setAttribute('href', targetVariantUrl);
          }
          if (productCardLink && targetVariantUrl) {
            productCardLink.setAttribute('href', targetVariantUrl); 
          }

          if (atcFormId  && targetVariantUrl) {
            atcFormId.setAttribute('value', targetVariantId)
          }

          if (addToCartButton) {
            if (targetVariantStock <= 0) {
              // only add if not already disabled
              if (!addToCartButton.hasAttribute('disabled')) {
                addToCartButton.setAttribute('disabled', 'disabled');
              }
            } else {
              // only remove if currently disabled
              if (addToCartButton.hasAttribute('disabled')) {
                addToCartButton.removeAttribute('disabled');
              }
            }
          }
  
          // 4. Toggle 360 viewers
          viewers.forEach(viewer => {
            const viewerId = viewer.getAttribute('data-variant-id');
            if (viewerId === targetVariantId) {
              viewer.classList.add('active');
            } else {
              viewer.classList.remove('active');
            }
          });

          let html = '';

          switch (stockHandle) {
            case 'in_stock':
              html = `
                <div class="stock-indicator in-stock">
                  <span class="text">
                    <span class="dot green"></span>${stockLabel || 'In Stock'}</span>
                </div>
              `;
              break;

            case 'limited_stock':
              html = `
                <div class="stock-indicator limited-stock">
                  <span class="text">
                    <span class="dot yellow"></span>${stockLabel || 'Limited Stock'}</span>
                </div>
              `;
              break;

            case 'out_of_stock':
              html = `
                <div class="stock-indicator out-of-stock">
                  <span class="text">
                    <span class="dot red"></span>${stockLabel || 'Out of Stock'}</span>
                </div>
              `;
              break;

            case 'preorder':
              const p1 = this.getAttribute('data-preorder-1') || '';
              const p2 = this.getAttribute('data-preorder-2') || '';
              const p3 = this.getAttribute('data-preorder-3') || '';

              html = `
                <div class="stock-indicator preorder">
                  <span class="text">
                    <span class="dot yellow"></span>
                    <strong>Pre-Order</strong> – ${p1}
                    <strong><u>${p2}</u></strong>
                    ${p3}
                  </span>
                </div>
              `;
              break;

            default:
              html = `<div class="stock-indicator stock-indicator-empty"></div>`;
          }

          stockWrapper.innerHTML = html;
          
        });
      });
  
      // Set initial label and viewer state
      const firstSwatch = swatches[0];
      const firstAlt = firstSwatch?.querySelector('img')?.alt || '';
      const firstTitle = firstSwatch?.getAttribute('data-variant-title') || ''; 
      const firstUrl = firstSwatch?.getAttribute('data-variant-url') || ''; 
      if (label) label.textContent = firstTitle || firstAlt;
  
      if (shopNowButton && firstUrl) {
        shopNowButton.setAttribute('href', firstUrl); 
      }
      if (productCardLink && firstUrl) {
        productCardLink.setAttribute('href', firstUrl); 
      }
  
      const initialVariantId = firstSwatch?.getAttribute('data-variant-id');
      viewers.forEach(viewer => {
        const viewerId = viewer.getAttribute('data-variant-id');
        viewer.classList.toggle('active', viewerId === initialVariantId);
      });
    }
  }
  
  

  function onDOMContentLoaded() {
    const path = location.pathname;
    const isHomePage = path == "/";
    const isProducts = path.includes("/products");
    const isCollections = path.includes("/collections") && !isProducts;
    const isCart = path == "/cart";

    customElements.define("convx-three-sixty", ConvxThreeSixty);
    customElements.define("convx-product-card", ConvxProductCard);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded, {
      once: true,
    });
  } else {
    onDOMContentLoaded();
  }
})();
